/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

$(document).ready(function () {
  $('#charity').appendTo('.charity-selector');
});

  
  // Get the modal
var modal = document.getElementById("charity");

// Get the button that opens the modal
var btns = document.querySelectorAll(".learnmore");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks on the button, open the modal
  btns.forEach((btn) => {
  btn.onclick = function() {
   console.log($(btn).siblings('input').attr('data-index'));
    $('.charity-selection-block').removeAttr('style');
    $('.charity-index-'+$(btn).siblings('input').attr('data-index')).css('display','block');
  modal.style.display = "block";
}
});


// When the user clicks on <span> (x), close the modal
span.onclick = function(event) {

  modal.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}
/*
document.querySelectorAll('.charity-radio').forEach(radioclick);
  
  function radioclick(radio) {
      radio.addEventListener('click', function() {
   
    //  document.querySelector(".radio-wrapper input[data-index='"+this.dataset.index+"']").click();
  });
  }

document.querySelectorAll('.radio-wrapper input').forEach(radiocart);
    function radiocart(radio) {
      radio.addEventListener('click', function(event) {
   
     // event.preventDefault();
      //document.querySelector(".charity-radio[data-index='"+this.dataset.index+"']").click();
  });
  }
*/


  $(document).ready(function () {

updateElevateZoom();
// Function to update the zoom on the selected slide
function updateElevateZoom() {
    // If the window width is less than or equal to 768 pixels, do not initialize ElevateZoom
  if (window.innerWidth <= 768) {
    return;
  }

  // Get the selected slide image element
  var $selectedImageElement = $('.product__slide.is-selected img[data-product-image]');

  // Initialize elevateZoom with inner zoom option on the selected image after it has been fully loaded
  $selectedImageElement.on('load', function () {
    $selectedImageElement.elevateZoom({
      zoomType: 'inner',
      cursor: 'crosshair',
      responsive: true,
    });
  });

  // Trigger the load event if the image is already loaded
  if ($selectedImageElement[0].complete) {
    $selectedImageElement.trigger('load');
  }
}



    
  });


  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
